const bookingCancelRoutes = [
    {
        path: '/booking_cancel',
        name: 'booking_cancel',
        children: [
            {
                path: '',
                name: 'bookingCancelList',
                component: () => import('@/modules/booking_cancel/list/List.vue'),
                meta: {
                    resource: 'bookings',
                    action: 'view',
                    layout: 'default',
                    auth: true,
                    title: 'Booking Cancel',
                    breadcrumbs: [{ title: 'Booking Cancel', routeName: 'bookingCancelList' }]
                }
            }
        ]
    }
]

export default bookingCancelRoutes
